import React, { useEffect } from "react";
// import QRCode from "react-qr-code";
import Image from "react-bootstrap/Image";
import StyledFSSCert from "./fssStyled";
import { currencyFormatter, getAssetURL } from "../../utils";
import cert from "../../assets/fss_template.png";
//capture is used to generate borrower certificate
//html2canvas does not allow cross-origin integration without proxy
//so capture asset must be hosted in the repo

const FSSCertificate = ({
  captureRef,
  loan,
  load,
  //   handleCapture,
  handleCanvasDataURL,
}) => {
  const [ready, setReady] = load;

  useEffect(() => {
    if (ready) {
      handleCanvasDataURL();
    }
  }, [ready, handleCanvasDataURL]);

  return (
    <StyledFSSCert className={"capture"}>
      <Image className="cert-bg" src={getAssetURL("cert-bg.svg")} />
      <Image className="tassles" src={getAssetURL("tassles.svg")} />
      <div className="canvas-box" ref={captureRef}>
        {ready && (
          <>
            <div className="canvas-amount awarded">
              <strong>
                {currencyFormatter(parseInt(loan?.loanAmount)) + "*"}
              </strong>
            </div>
            <div className="canvas-name awarded">
              <strong>{loan?.borrowerName}</strong>
            </div>
            {/* <Image className="canvas-cert" src={cert} fluid /> */}
          </>
        )}
        <Image
          onLoad={() => setReady(true)}
          className="canvas-cert"
          //   src={getAssetURL("fss_template.png")}
          src={cert}
        />
      </div>
      {/* <Image
        title="Click to Download Certificate!"
        className="dlIcon"
        onClick={handleCapture}
        src={dlIcon}
      /> */}
    </StyledFSSCert>
  );
};
export default FSSCertificate;
